if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();

      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      };

      this.mql = window.matchMedia('(min-width: 750px)');
      this.productInfo = document.getElementById(`ProductInfo-${this.dataset.section}`);

      if (this.productInfo && Shopify.postLinksRetry) {
        this.productInfo.initShareLinks();
      }

      if (!this.elements.thumbnails || !this.elements.viewer) return;

      this.elements.viewer.addEventListener(
        'slideChanged',
        debounce(this.onSlideChanged.bind(this), 500)
      );

      this.elements.thumbnails
        .querySelectorAll('[data-target]')
        .forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener(
              'click',
              this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false)
            );
        });

      if (
        this.dataset.desktopLayout &&
        this.dataset.desktopLayout.includes('thumbnail') &&
        this.mql.matches
      ) {
        this.removeListSemantic();
      }
    }

    onSlideChanged(event) {
      if (
        !event ||
        !event.detail ||
        !event.detail.currentElement ||
        !event.detail.currentElement.dataset
      ) {
        return;
      }

      const mediaId = event.detail.currentElement.dataset.mediaId;
      if (!mediaId) return;

      if (!this.elements.thumbnails) return;

      const thumbnail = this.elements.thumbnails.querySelector(
        `[data-target="${mediaId}"]`
      );

      if (!thumbnail) return;

      this.setActiveThumbnail(thumbnail);
    }

    setActiveMedia(mediaId, prepend) {
      const activeMedia = this.elements.viewer.querySelector(
        `[data-media-id="${mediaId}"]`
      );

      if (!activeMedia) return;

      this.elements.viewer
        .querySelectorAll('[data-media-id]')
        .forEach((element) => {
          element.classList.remove('is-active');
        });

      activeMedia.classList.add('is-active');

      if (prepend) {
        activeMedia.parentElement.prepend(activeMedia);

        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(
            `[data-target="${mediaId}"]`
          );
          if (activeThumbnail) {
            activeThumbnail.parentElement.prepend(activeThumbnail);
          }
        }

        if (this.elements.viewer.slider) {
          this.elements.viewer.resetPages();
        }
      }

      this.preventStickyHeader();

      window.setTimeout(() => {
        if (this.elements.thumbnails && activeMedia.parentElement) {
          activeMedia.parentElement.scrollTo({
            left: activeMedia.offsetLeft
          });
        }

        if (
          !this.elements.thumbnails ||
          this.dataset.desktopLayout === 'stacked'
        ) {
          activeMedia.scrollIntoView({ behavior: 'smooth' });
        }
      });

      this.playActiveMedia(activeMedia);

      if (!this.elements.thumbnails) return;

      const activeThumbnail = this.elements.thumbnails.querySelector(
        `[data-target="${mediaId}"]`
      );

      if (!activeThumbnail) return;

      const position =
        activeThumbnail.dataset ? activeThumbnail.dataset.mediaPosition : '';

      this.setActiveThumbnail(activeThumbnail);
      this.announceLiveRegion(activeMedia, position);
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails
        .querySelectorAll('button')
        .forEach((element) => element.removeAttribute('aria-current'));

      const btn = thumbnail.querySelector('button');
      if (btn) btn.setAttribute('aria-current', true);

      if (
        this.elements.thumbnails.isSlideVisible &&
        this.elements.thumbnails.isSlideVisible(thumbnail, 10)
      ) return;

      if (this.elements.thumbnails.slider) {
        this.elements.thumbnails.slider.scrollTo({
          left: thumbnail.offsetLeft
        });
      }
    }

    announceLiveRegion(activeItem, position) {
      if (!this.elements.liveRegion) return;

      const image = activeItem.querySelector(
        '.product__modal-opener--image img'
      );

      if (!image) return;

      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);

        if (window.accessibilityStrings?.imageAvailable) {
          this.elements.liveRegion.innerHTML =
            window.accessibilityStrings.imageAvailable.replace(
              '[index]',
              position
            );
        }

        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };

      if (image.src) {
        image.src = image.src;
      }
    }

    playActiveMedia(activeItem) {
      if (typeof window.pauseAllMedia === 'function') {
        window.pauseAllMedia();
      }

      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia && typeof deferredMedia.loadContent === 'function') {
        deferredMedia.loadContent(false);
      }
    }

    preventStickyHeader() {
      this.stickyHeader =
        this.stickyHeader || document.querySelector('sticky-header');

      if (!this.stickyHeader) return;

      this.stickyHeader.dispatchEvent(
        new Event('preventHeaderReveal')
      );
    }

    removeListSemantic() {
      if (!this.elements.viewer || !this.elements.viewer.slider) return;

      this.elements.viewer.slider.setAttribute('role', 'presentation');

      if (this.elements.viewer.sliderItems) {
        this.elements.viewer.sliderItems.forEach((slide) => {
          slide.setAttribute('role', 'presentation');
        });
      }
    }
  });
}